import { CircleButton } from '../../../../components/elements/CircleButton';
import '../../../style.css'

export const TopPart = ({ state, topNumbers, bottomNumbers, timeduration, result, level }) => {
    const Fraction = ({ value }) => {
        const [num, den] = value.split('/');

        return (
            <div className="flex flex-col items-center leading-none">
                <div>{num}</div>
                <div className="w-full border-t-[2px] border-white my-[2px]" />
                <div>{den}</div>
            </div>
        );
    };


    return (
        <div
            className={`flex overflow-hidden items-center w-full border-[3px] rounded-[16px] border-[#2F9EBA] bg-[#FFF] lg:rounded-[20px] 
                       ${state ? "toppartIsStateHeight" : "toppartIsNotStateHeight"}
                       text-[#FFF] font-bigfatScript justify-around
            `}
        >
            <div className={`w-[169px] h-[86px] xs:h-[96px] text-[32px] rounded-[16px] mx-[5px] xs:mx-0
               ${state ? "md:w-[172px] md:h-[100px]  md:rounded-[16px] lg:w-[238px] lg:h-[120px] lg:rounded-[20px] md:text-[32px] lg:text-[40px] xl:text-[48px] xl:w-[313px] xl:h-[150px]  xl:rounded-[20px]" :
                    "xl:w-[370px] xl:h-[160px]  xl:rounded-[20px] md:w-[236px] md:h-[100px] md:rounded-[20px] xl:text-[64px] md:text-[40px] lg:text-[48px] lg:w-[295px] lg:h-[120px] lg:rounded-[20px] "} bg-[#85B054] flex justify-around items-center`}>
                <Fraction value={topNumbers[0]} />
            </div>
            <CircleButton className={"addingresult"} isActive={result === "?" ? false : result}>
                <div className='adding'>
                    {result}
                </div>

            </CircleButton>
            <div className={`w-[169px] h-[86px] xs:h-[96px] text-[32px] rounded-[16px] mx-[5px] xs:mx-0
               ${state ? "md:w-[172px] md:h-[100px] md:text-[32px] md:rounded-[16px] lg:w-[238px] lg:h-[120px] lg:rounded-[20px] lg:text-[40px] xl:w-[313px] xl:h-[150px] xl:text-[48px] xl:rounded-[20px]" :
                    "xl:w-[370px] xl:h-[160px] xl:text-[64px] xl:rounded-[20px] md:w-[236px] md:h-[100px] md:rounded-[20px] md:text-[40px] lg:w-[295px] lg:h-[120px] lg:rounded-[20px] lg:text-[48px]"} bg-[#85B054] flex justify-around items-center`}>
                    <Fraction value={bottomNumbers[0]} />
            </div>
        </div>
    )
}